import type { AuditLogEntityName } from "@/api-schema-enums";
import { AuditLogTimeline } from "@/components/audit-log/audit-log-timeline";

interface AuditLogTabProps {
  entityName: AuditLogEntityName;
  uuid: string;
}

export const AuditLogTab = ({ entityName, uuid }: AuditLogTabProps) => (
  <AuditLogTimeline entityName={entityName} uuid={uuid} enabled />
);
